/* eslint-disable prettier/prettier */
/* eslint-disable no-nested-ternary */
import React from 'react';
import Loading from '@gp/components/Loading';
import NoData from '@gp/components/NoData';
import CardSlot from '@gp/components/CardSlot';
import SpendDate from './SpendDate';
import CurrentHeadcount from './CurrentHeadcount';
import NetProfitCard from './NetProfitCard';
import { isEmpty, formatDateStr } from '@gp/utils/common';
import { getMetriCardTitleTips } from '../../utils/tips';

import type { IBaseProps } from '@home/types/common';

import './index.scss';
import { IRecord } from '@gp/types/global';

type IFinanceMetricType = '1' | '2' | '3' | (string & {});

interface IFinanceCardProps extends IBaseProps {
  type: IFinanceMetricType;
  title: string;
  loading?: boolean;
  data?: any;
}

const isSpendDateNoData = (data: IRecord<string>): boolean => {
  const { launch, spend_to_date: spendToDate, of_total_budget: ofTotalBudget } = data || {};
  return isEmpty(launch) && isEmpty(spendToDate) && isEmpty(ofTotalBudget);
};

const isCurrentHeadcountLineChartsNoData = (list: any[]): boolean => {
  if (!Array.isArray(list) || !list.length) return true;
  return list.every((item) => isEmpty(Object.values(item)?.[0]));
};

const isCurrentHeadcountNoData = (data: IRecord<any>): boolean => {
  const { value, line_chart: lineCharts } = data || {};
  return isEmpty(value) && isCurrentHeadcountLineChartsNoData(lineCharts);
};

const isNetProfitNoData = (data: IRecord<any>): boolean => {
  const { min, max, studio, bpm, fbi } = data || {};
  return isEmpty(min) && isEmpty(max) && isEmpty(studio) && isEmpty(bpm) && isEmpty(fbi);
};

const getUpdateTimeOfMetric = (type?: IFinanceMetricType, data?: { date: string; update_time?: string }): string => {
  const { date, update_time: updateTime } = data || {};
  if (type === '3') return formatDateStr(updateTime, 'YYYY-MM');
  return formatDateStr(date, 'YYYY-MM');
};

const FinanceCard: React.FC<IFinanceCardProps> = (props) => {
  const { type, title, loading, data } = props;

  const dataDateFormatted = getUpdateTimeOfMetric(type, data);

  const renderSpendDateUI = () => {
    if (isSpendDateNoData(data)) return <NoData height={80} />;
    return <SpendDate data={data} />;
  };

  const renderCurrentHeadconutUI = () => {
    if (isCurrentHeadcountNoData(data)) return <NoData height={80} />;
    return <CurrentHeadcount data={data} />;
  };

  const renderNetProfitUI = () => {
    if (isNetProfitNoData(data)) return <NoData height={80} />;
    return <NetProfitCard data={data} />;
  };

  return (
    <CardSlot
      className="dbg-finance-card-details"
      title={
        <div className="dbg-finance-card-title-container">
          {getMetriCardTitleTips(title, dataDateFormatted)}
          <div className="dbg-finance-card-time">{dataDateFormatted}</div>
        </div>
      }
    >
      {loading && <Loading style={{ height: 80 }} loading />}
      {!loading && (
        <>
          {type === '1' ? (
            renderSpendDateUI()
          ) : type === '2' ? (
            renderCurrentHeadconutUI()
          ) : (
            renderNetProfitUI()
          )}
        </>
      )}
    </CardSlot>
  );
};

export default FinanceCard;
